import { defineStore, mapActions } from "pinia";
import { useAxiosStore } from "js/stores/axiosStore.js";

export const useUtilsStore = defineStore("utilsStore", {
    state: () => ({
        _companions: null,
    }),
    getters: {
        async companions(state) {
            if (state._companions === null) {
                state._companions = await this.fetch("/api/utils/companions");
            }
            return state._companions;
        },
    },
    actions: {
        invalidate(util) {
            if (util === undefined || util === "companions") {
                this._companions = null;
            }
        },
        async pexelsImages(query) {
            return this.fetch("/api/utils/pexels-images", { query });
        },
        ...mapActions(useAxiosStore, ["fetch"]),
    },
});
